// extracted by mini-css-extract-plugin
module.exports = {"title":"login_title__X_0fW"};